module.exports = __webpack_public_path__ + "img/threat-analytics-devices.ba18c208.png";